

































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { URI_QRCODE_SCHEME_PREFIX } from "@/constants";

@Component
export default class QrModal extends Vue {
  @Prop({ required: true }) public address: string;

  private isCollapsed = true;
  private amount = 0;
  private vendorField = "";

  get qrValue() {
    return this.isCollapsed ? this.address : `${URI_QRCODE_SCHEME_PREFIX}${this.address}${this.formattedParams}`;
  }

  get formattedParams() {
    const params = [];

    if (this.amount) {
      params.push(`amount=${this.amount}`);
    }

    if (this.vendorField) {
      params.push(`vendorField=${this.vendorField}`);
    }

    return params.length > 0 ? `?${params.join("&")}` : "";
  }

  private onInputChange(event: any) {
    const { name, value } = event.target;
    this[name] = value;
  }

  @Watch("isCollapsed")
  public onStatusChanged() {
    this.amount = undefined;
    this.vendorField = undefined;
  }

  public emitClose() {
    this.$emit("close");
  }
}
